import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  ModalHeader,
  VStack,
  HStack,
  Box,
  Image,
  Text,
  Button,
} from "@chakra-ui/react";
import { pxToRem } from "../../utils/editor";
import { paymentMethods } from "../../utils/const";

interface PaymentModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedPaymentMethod: string | null;
  onSelectPaymentMethod: (method: string) => void;
  onContinuePayment: () => void;
  isLoading: boolean;
}

const PaymentModal: React.FC<PaymentModalProps> = ({
  isOpen,
  onClose,
  selectedPaymentMethod,
  onSelectPaymentMethod,
  onContinuePayment,
  isLoading,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay
        background={"blackAlpha.300"}
        backdropFilter={"blur(8px)"}
      />
      <ModalContent
        maxW={pxToRem(846)}
        borderRadius={pxToRem(20)}
        p={pxToRem(28)}
      >
        <ModalHeader
          fontSize={pxToRem(32)}
          fontWeight="700"
          textAlign="left"
          p={0}
        >
          Secure Payment
        </ModalHeader>
        <Text
          fontSize={pxToRem(16)}
          color="gray.500"
          textAlign="left"
          mt={pxToRem(6)}
        >
          Choose your payment method
        </Text>
        <ModalCloseButton size="lg" />
        <ModalBody pt={pxToRem(24)}>
          <VStack>
            <HStack
              spacing={pxToRem(36)}
              width="50%"
              justifyContent="center"
            >
              {/* 使用循环渲染支付方式选项 */}
              {paymentMethods.map((method) => (
                <Box
                  key={method.id}
                  minW={pxToRem(158)}
                  px={pxToRem(20)}
                  py={pxToRem(16)}
                  border="1px solid"
                  borderColor={
                    selectedPaymentMethod === method.id
                      ? "#1D8AFF"
                      : "#E1E6EF"
                  }
                  bgColor={
                    selectedPaymentMethod === method.id
                      ? "rgba(56, 152, 255, 0.14)"
                      : "#fff"
                  }
                  borderRadius={pxToRem(12)}
                  cursor="pointer"
                  onClick={() => onSelectPaymentMethod(method.id)}
                  bg={
                    selectedPaymentMethod === method.id
                      ? "blue.50"
                      : "white"
                  }
                >
                  <Image
                    w={pxToRem(24)}
                    h={pxToRem(24)}
                    objectFit="contain"
                    src={method.icon}
                    mb={pxToRem(6)}
                  />
                  <Text fontSize={pxToRem(14)} fontWeight="500" mb={0}>
                    {method.name}
                  </Text>
                </Box>
              ))}
            </HStack>

            {/* 继续按钮 */}
            <Button
              bg="#1D8AFF"
              color="white"
              height={pxToRem(48)}
              borderRadius={pxToRem(12)}
              fontSize={pxToRem(24)}
              fontWeight="700"
              mt={pxToRem(40)}
              py={pxToRem(16)}
              px={pxToRem(48)}
              _hover={{
                bg: "#1974E8",
                transform: `translateY(${pxToRem(-1)})`,
              }}
              onClick={onContinuePayment}
              isDisabled={!selectedPaymentMethod}
              isLoading={isLoading}
            >
              Continue
            </Button>

            <Text
              fontSize={pxToRem(16)}
              color="#333"
              textAlign="center"
              mt={pxToRem(8)}
              mb={0}
            >
              By clicking Continue, you'll proceed to your purchase details.
              <br />
              You can review everything before confirming.
            </Text>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default PaymentModal;